export const minus = () => (
  <path
    d="M5 12h14"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
